export default __webpack_public_path__ + "static/media/q2_2_step7.9bc09935.png";